import { toast as toastNative } from 'react-toastify'

import { createAction as createActionNative, createAsyncThunk as createAsyncThunkNative } from '@reduxjs/toolkit'
import { ReduxConfiguration } from 'packages/redux-toolkit'

const reduxToolkitWithRejected = new ReduxConfiguration({
  createAction: createActionNative,
  createAsyncThunk: createAsyncThunkNative,
  toast: toastNative,
  deleteLastPoint: true,
})

export const { createAction, createAsyncThunk, rejectedToastifyMiddleware, getCreatorAsyncSlice } =
  reduxToolkitWithRejected
